import React, { Component } from 'react';
import cn from 'classnames';

import './Insights.scss';

import summary from '../mock_data/summary';

class SummarySelection extends Component {
  state = {
    quoteIdx: 0,
    quoteIdx2: 0,
    quoteIdx3: 0,
    quoteIdx4: 0,
  };

  getQuotes = () => ['1. Correct <br> 2. Yep', 'How often do you feel the need for a product like this?'];

  getProducts = () => [
    { name: 'Product A', percentage: 66.7 },
    { name: 'Product B', percentage: 54 },
    { name: 'Product C', percentage: 32 },
    { name: 'Product D', percentage: 32 },
    { name: 'Product E', percentage: 24 },
  ];

  render() {
    const { quoteIdx } = this.state;
    const quotes = this.getQuotes();
    const products = this.getProducts();
    return (
      <div className='summary-selection-outer-container'>
        <div className='general-stats-container panel'>
          <div className='general-stats subpanel dark'>
            <div className='stat-header'>Overview</div>
            <div className='stat-item'>
              <div className='stat-num'>32</div>
              <div className='stat-label'>Total Calls</div>
            </div>
            <div className='stat-item'>
              <div className='stat-num'>6</div>
              <div className='stat-label'>Calls resulted in a close</div>
            </div>
            <div className='stat-item'>
              <div className='stat-num'>11</div>
              <div className='stat-label'>Calls with a follow-up</div>
            </div>
          </div>
          <div className='general-stats words-section subpanel'>
            <div>
              <div className='words-header'>
                {quoteIdx === 0 && <div>Words That Lead To Positive Outcomes</div>}

                {quoteIdx === 1 && <div>Words That Lead To Negative Outcomes</div>}

                <div className='dashes'>
                  {[...Array(quotes.length).keys()].map((idx) => (
                    <div key={idx} onClick={() => this.setState({ quoteIdx: idx })} className={cn('dash', { active: quoteIdx === idx })} />
                  ))}
                </div>
              </div>

              {quoteIdx === 0 && (
                <div>
                  <div className='word'>1. Correct</div>
                  <div className='word'>2. Yep</div>
                  <div className='word'>3. Perfect</div>
                  <div className='word'>4. Awesome</div>
                  <div className='word'>5. Fine</div>
                  <div className='word'>6. Quarterly</div>
                  <div className='word'>7. Elite</div>
                  <div className='word'>8. Strategy</div>
                  <div className='word'>9. Yes</div>
                  <div className='word'>10. Easier</div>
                </div>
              )}

              {quoteIdx === 1 && (
                <div>
                  <div className='word'>1. Renewal</div>
                  <div className='word'>2. Apologize</div>
                  <div className='word'>3. Sorry</div>
                  <div className='word'>4. Colleague</div>
                  <div className='word'>5. Stuck</div>
                  <div className='word'>6. Problem</div>
                  <div className='word'>7. Log</div>
                  <div className='word'>8. Basically</div>
                  <div className='word'>9. Trading</div>
                  <div className='word'>10. Risk</div>
                </div>
              )}
            </div>
          </div>
          <div className='general-stats most-mentioned subpanel'>
            <div className='most-mentioned-header'>Top 5 Most Mentioned Products</div>
            <div className='most-mentioned-bar-chart'>
              {products.map(({ name, percentage }, idx) => (
                <div key={idx} className='product-mention'>
                  <div className='percentage'>{percentage}%</div>
                  <div className='bar-wrapper'>
                    <div style={{ width: `${percentage}%` }} className='background' />
                    <div className='text'>{name}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='general-stats-container panel'>
          {summary.best.map(([{ title }, items], idx) => {
            const indexName = ['quoteIdx2', 'quoteIdx3', 'quoteIdx4'][idx];
            const indexSelected = this.state[indexName];
            return (
              <div key={idx} className='general-stats qa-section subpanel'>
                <div>
                  <div className='qa-header'>
                    <div>{title}</div>
                    <div className='dashes'>
                      {[...Array(items.length).keys()].map((idx) => (
                        <div
                          key={idx}
                          onClick={() => this.setState({ [indexName]: idx })}
                          className={cn('dash', { active: indexSelected === idx })}
                        />
                      ))}
                    </div>
                  </div>
                  <div className='qa-body'>
                    {idx === 2 &&
                      items[indexSelected].highlights.slice(0, 1).map((quote, idx) => (
                        <div key={idx}>
                          <b>"{quote}"</b>
                        </div>
                      ))}
                    {idx === 0 && items[indexSelected].highlights.slice(0, 1).map((quote, idx) => <div key={idx}>"{quote}"</div>)}
                    {idx === 1 && items[indexSelected].highlights.slice(0, 1).map((quote, idx) => <div key={idx}>"{quote}"</div>)}
                    {items[indexSelected].highlights.slice(1, 5).map((quote, idx) => (
                      <div key={idx}>"{quote}"</div>
                    ))}
                  </div>
                </div>
                {items[indexSelected].best && (
                  <div>
                    <div className='qa-best-header'>Best Response</div>
                    <div className='qa-best'>"{items[indexSelected].best}"</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default SummarySelection;
